// src/App.js
import React from "react";
import "./App.css";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Experience from "./components/Experience";
import Certifications from "./components/Certifications";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";

function App() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <section id="home" className="section dark">
          <Home />
        </section>

        <section id="about" className="section light">
          <About />
        </section>

        <section id="experience" className="section dark">
          <Experience />
        </section>

        <section id="certifications" className="section light">
          <Certifications />
        </section>

        <section id="projects" className="section dark">
          <Projects />
        </section>

        <section id="skills" className="section light">
          <Skills />
        </section>

        <section id="testimonials" className="section dark">
          <Testimonials />
        </section>

        <section id="contact" className="section light">
          <Contact />
        </section>
      </main>
    </div>
  );
}

export default App;
